import axios from 'axios'
import _ from  'lodash'

import { getName } from './util'

export default ({
  type = '',
  state = [],
  reduxArr = [],
	
  api = '',
  params = {},
	
  format
}) => {
  const action_success = `${ type }_success`
  const action_error = `${ type }_error`
  const action_reset = `${ type }_reset`
  const action_loading = `${ type }_loading`
  const action_loaded = `${ type }_loaded`
	
  const initState = {
    loading: false,
    msg: '',
    init: false,
		
    query: null,
    data: [],
		
    ...state
  }
	
  if (_.isPlainObject(reduxArr)) {
    reduxArr = [reduxArr]
  }
	
  reduxArr = reduxArr
    .concat({
      action: action_success,
      result: (state, payload) => ({
        ...state,
        ...payload,
			
        msg: ''
      })
    })
    .concat({
      action: action_error,
      result: (state, payload) => ({
        ...state,
			
        msg: payload
      })
    })
    .concat({
      action: action_reset,
      result: (state, payload) => ({
        ...initState
      })
    })
    .concat({
      action: action_loading,
      result: (state, payload) => ({
        ...state,
			
        loading: true
      })
    })
    .concat({
      action: action_loaded,
      result: (state, payload) => ({
        ...state,
			
        loading: false
      })
    })
	
  const common_success = (payload) => ({ payload, type: action_success })
  const common_error = (payload) => ({ payload, type: action_error })
  const common_reset = (payload) => ({ payload, type: action_reset })
  const common_loading = (payload) => ({ payload, type: action_loading })
  const common_loaded = (payload) => ({ payload, type: action_loaded })
	
  return {
    reducer: (state = initState, action) => {
      const { type, payload } = action
			
      for (let i = 0, len = reduxArr.length; i < len; i++) {
        if (type === reduxArr[i].action) {
          return reduxArr[i].result(state, payload)
        }
      }
			
      return state
    },
		
    common_success,
    common_error,
    common_reset,
    common_loading,
    common_loaded,
		
    [getName(type, 'get')]: (_params = {}, ignoreCache) => {
      return async (dispatch, getStore) => {
        const {
          [type]: {
            loading,
            query,
            data
          }
        } = getStore()
				
        const assignParams = Object.assign({}, _params, params)
        
        if (!ignoreCache && _.isEqual(query, assignParams)) {
          return [null, data]
        }
				
        dispatch(common_loading())
				
        const [err, res] = await axios.post(api, assignParams)
				
        dispatch(common_loaded())
				
        if (format instanceof Function) {
          return format([err, res], dispatch)
        }
				
        if (err) {
          dispatch(common_error(err))
          return [err]
        }
				
        if (!res) {
          dispatch(common_error('返回数据不正确或为空！'))
          return ['返回数据不正确或为空']
        }
				
        dispatch(common_success({
          init: true,
          query: assignParams,
          data: res
        }))
        
        return [null, res]
      }
    }
  }
}
